import './empty-state.less';

import React, { FC, ReactNode } from 'react';
import clsx from 'clsx';
import NikeLogoIcon from '../../icons/NikeLogoIcon';

interface EmptyStateProps {
    stateIcon?: ReactNode;
    text?: string;
    className?: string;
    disablePad?: boolean;
    textAboveIcon?: boolean;
    buttonText?: string;
    buttonOnClick?: any;
    buttonClassName?: string;
}

const EmptyState: FC<EmptyStateProps> = ({
    stateIcon = <NikeLogoIcon width="76" height="32" opacity="1" fill="#aab2bd" />,
    text = 'No data',
    className,
    textAboveIcon,
    buttonText,
    buttonOnClick,
    buttonClassName
}) =>
    textAboveIcon ? (
        <div className={clsx('empty-state', className)}>
            <div className="fs-14 c-black-50 px-20 py-30 pt-10">
                {text}
                <div className="not-found-posts-icon">{stateIcon && stateIcon}</div>
            </div>
        </div>
    ) : (
        <div className={clsx('py-30 px-20 text-center', className)}>
            {stateIcon && stateIcon}
            <div className="fs-14 c-black-50 px-20 py-15">{text}</div>
            {buttonText ? (
                <button className={buttonClassName} onClick={buttonOnClick}>
                    {buttonText}
                </button>
            ) : null}
        </div>
    );

export default EmptyState;
